import React from 'react';
import Main from './components/MainComponent'
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import './App.css';

function App() {
  const theme = createTheme({
  typography: {
    fontFamily: 'Raleway, sans-serif', // Set Raleway as the default font
    body2: {
      fontFamily: 'Raleway, sans-serif',
      fontWeight: 500, // Regular weight
    },
    body1: {
      fontFamily: 'Raleway, sans-serif',
      fontWeight: 500, // Regular weight
    },
    h4: {
      fontFamily: "'Raleway', sans-serif",
      color: '#124e8f',
      fontWeight: 'bold'
    },
    h1: {
      fontFamily: "'Raleway', sans-serif",
    },
    h5: {
      fontFamily: "'Raleway', sans-serif",
      fontWeight: 'bold',
      color: '#124e8f',
    },
    h6: {
      fontFamily: "'Raleway', sans-serif",
      color: '#124e8f',
      fontWeight: 'bold'
    },
    h7: {
      fontFamily: "'Raleway', sans-serif",
    }
  },
  palette: {
    background: {
      default: '#ffffff',
    },
    text: {
      primary: '#888c92',
    },
  },
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "'Raleway', sans-serif",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Raleway', sans-serif",
          textTransform: 'none',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontFamily: "'Raleway', sans-serif",
      },
    },
  },
  },
});


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Main/>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
